<template>
<div>
  
     <div>
      <!-- generated code  -->
      <div class="flex flex-col w-full mt-4">
        <div class="flex flex-row">
          <div class="flex flex-col w-2/5 mr-2">
            <div class="text-xs text-blue font-medium">{{ $t("code") }}</div>
            <div class="flex flex-row w-full">
              <input
                v-model="codedName"
                readonly
                class="w-full h-8 bg-grey-lighter border border-grey-light rounded p-1 text-xs"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- nuevo fichero, mostrar todos los select para codificar nombre -->
    <div v-if="isNewFile">
      <!-- nombre descriptiovo -->
      <div class="flex flex-col w-full mb-4">
        <b-field 
        :label="$t('descriptive_name')"
        class="mb-4">
          <input
            v-model="desc_name"
            type="text"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 p-2"
          />
        </b-field>
      </div>

      <div class="flex gap-4 mb-4">
        <b-field label="Selecciona una fase" class="mb-4">
          <b-select
            v-model="dataOptions.faceCode"
            placeholder="Selecciona una fase"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
          >
            <option
              v-for="phase in phaseCodes"
              :key="phase.code"
              :value="phase.code"
            >
              {{ phase.description }} ({{ phase.code }})
            </option>
          </b-select>
        </b-field>
        
        <b-field v-if="phaseSubdivision" label="Subdivisión de fase" class="mb-4">
          <input
            v-model="dataOptions.phaseSubdivisionNumber"
            type="number"
            min="0"
            max="99"
            placeholder=""
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 p-2"
          />
        </b-field>
        
        
      </div>

      <div class="flex gap-4 mb-4">
        <b-field label="Tipo de documento" class="mb-4">
          <b-select
            v-model="selectedParent"
            placeholder="Tipo de documento"
            class="w-full"
          >
            <option
              v-for="parent in documentTypes"
              :key="parent.code"
              :value="parent.code"
            >
              {{ parent.code }} - {{ parent.description }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Codigo tipo de documento">
          <b-select
            v-model="dataOptions.fileType"
            placeholder="Código de Tipo de documento"
            class="w-full"
            :disabled="filteredChildren.length === 0"
          >
            <option
              v-for="child in filteredChildren"
              :key="child.code"
              :value="child.code"
            >
              {{ child.code }} - {{ child.description }}
            </option>
          </b-select>
        </b-field>
      </div>

      <b-field label="Código descriptivo">
        <b-select
          v-model="dataOptions.descriptionCode"
          placeholder="Selecciona un código descriptivo"
          class="w-full"
        >
          <option
            v-for="item in descriptionCodes"
            :key="item.code"
            :value="item.code"
          >
            {{ item.code }} - {{ item.description }}
          </option>
        </b-select>
      </b-field>

      <div class="flex gap-4 mb-4">
        <b-field label="Tipo de versión">
          <b-select
            v-model="dataOptions.versionType"
            placeholder="Selecciona un tipo de versión"
            class="w-full"
          >
            <option
              v-for="item in versionTypes"
              :key="item.code"
              :value="item.code"
            >
              {{ item.code }} - {{ item.description }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Número de versión">
          <b-input
            type="number"
            min="1"
            v-model="dataOptions.versionNumber"
            placeholder="Ej. 1"
            class="w-full"
          ></b-input>
        </b-field>
      </div>


    </div>

    <!-- nueva version. Mostrar solo el select de numero version si es detectado en el nombre -->
    <div v-if="!isNewFile && hasVersionNumber()" class="flex flex-row w-full pb-3 mt-4">
        Version:
        <div class="flex flex-col p-2 font-bold">R</div>
        <b-select v-model="version.cliente" :placeholder="'version cliente'" class="flex flex-col"
            :disabled="false && versionType!='cliente'"> <!-- forzado, nunca deshabilitado, siempre editable -->
            <option v-for="letter in abecedary" :value="letter" :key="'tvc_'+letter">
                {{ letter }}
            </option>
        </b-select>
        <b-select v-model="version.interna" :placeholder="'version interna'" class="flex flex-col"
            :disabled="false && versionType!='interna'"> <!-- forzado, nunca deshabilitado, siempre editable -->
            <option v-for="number in versionValues" :value="number" :key="'tvi_'+number">
                {{ number }}
            </option>
        </b-select>
    </div>



    <div class="cursor-default tag is-info" type="button" 
        @click="generateName">
        {{$t('generate_filename')}} <b-icon pack="fas" icon="file-alt" />
    </div>
    <!-- <div class="cursor-default tag is-warning" type="button" v-else >
        {{$t('generate_filename')}} <b-icon pack="fas" icon="file-alt" />
    </div> -->
</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'
import axios from 'axios';

export default {
  name: "codification-seiasa",

  components: {
  },


  props: {
    form: {type: Object, required: false},
    isNewFile: {type: Boolean, required: false, default: true}, // flag is new file (true), or is version (false)
    versionFileName: {type: String, required: false, default: ''}, // nombre del fichero al que subir version (para buscar patron en RXX en su nombre)
    file: {type: File, required: false, default: null}, // fichero a subir, para obtener nombre original
  },


  data: () => ({
    yearValues: [],
    abecedary: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    versionValues: [],
    version: { cliente: 'A', interna: '1'}, // versionado: RA1, RA2, RB4....
    versionType: 'cliente', // establece cual de los 2 se permite modificar (la letra de 'cliente' o la cifra de 'interna')
    desc_name: '',
    regex: /-R[A-Z]\d+/, // expresion regular que buscara si el versionFileName contiene el numero de version RXX que luego fue sustituido por "-R{letra}{digito}"

    options: {
      t0: [],
      t1: [],
      t2: [],
      t3: [],
    },
    // N Número
    // A Letra
    // X Letra o número
    dataOptions : {
      projectFileCode:'05-O25', // codigo de expediente de proyecto XX-XXX 
      companyCode: 'TRG', // codigo de empresa, AAA 
      faceCode:'', // AA
      fileType: '',
      phaseSubdivisionNumber: '',
      descriptionCode: '', // codigo de descripcion del documento, GEN, ESA, TOP...
      number:1,
      versionType: '',      // ← nueva propiedad
      versionNumber: 1,   // ← nueva propiedad
      versionCode: '', // codigo de version del fichero, ANN
    },





    codedName: '', // nombre generado del fichero codificado
    phaseSubdivision: true, // si es true se concatena numeracion a faceCode AANN
    
    phaseCodes : [
      { code: "GN", description: "General (aplicable a varias fases)" },
      { code: "EX", description: "Existente" },
      { code: "AA", description: "Análisis de alternativas" },
      { code: "EI", description: "Estudio Informativo" },
      { code: "AP", description: "Anteproyecto" },
      { code: "PB", description: "Proyecto básico" },
      { code: "PC", description: "Proyecto constructivo" },
      { code: "CO", description: "Construcción" },
      { code: "COPM", description: "Proyecto modificado" },
      { code: "COPC", description: "Proyecto complementario" },
      { code: "COPL", description: "Proyecto de liquidación" },
      { code: "COAB", description: "As-Built" },
      { code: "MA", description: "Mantenimiento" }
    ],

    selectedParent: '',
    selectedChild: '',

    documentTypes: [
      {
        code: 'ACT',
        description: 'Acta',
        children: [
          { code: 'AGA', description: 'Acta de garantía' },
          { code: 'APA', description: 'Acta de paralización' },
          { code: 'APR', description: 'Acta de pruebas' },
          { code: 'AIN', description: 'Acta de Inspección' },
          { code: 'ARD', description: 'Acta de reanudación' },
          { code: 'ARL', description: 'Acta de replanteo' },
          { code: 'ARE', description: 'Acta de recepción' },
          { code: 'ARP', description: 'Acta de recepción provisional' },
          { code: 'ARU', description: 'Acta de reunión' },
          { code: 'AVI', description: 'Acta de visita' }
        ]
      },
      {
        code: 'BIM',
        description: 'Building Information Modeling',
        children: [
          { code: 'M3D', description: 'Modelo 3D' },
          { code: 'MIP', description: 'Modelo de información propietario' },
          { code: 'MOP', description: 'Modelo de información OpenBIM' },
          { code: 'M2D', description: 'Modelo de planos' },
          { code: 'MFD', description: 'Modelo federado' },
          { code: 'NPU', description: 'Nube de Puntos' },
          { code: 'OBM', description: 'Objeto BIM' },
          { code: 'BEP', description: 'Plan de ejecución BIM' },
          { code: 'OIR', description: 'Requisitos de información de la organización (Organizational Information Requirements)' },
          { code: 'AIR', description: 'Requisitos de información del activo (Asset Information Requirement)' },
          { code: 'EIR', description: 'Requisitos de intercambio de información (Exchange Information Requirements)' },
          { code: 'PIR', description: 'Requisitos de información del proyecto (Project Information Requirement)' },
          { code: 'MID', description: 'Programa general de desarrollo de la información (Model Information Delivery Plan)' },
          { code: 'TID', description: 'Programa de desarrollo de la información de una tarea (TIDP)' },
          { code: 'PGS', description: 'Plan de gestión de la seguridad de la información' },
          { code: 'RIM', description: 'Registro de incidencias de modelos' }
        ]
      },
      {
        code: 'COM',
        description: 'Comunicación',
        children: [
          { code: 'CAR', description: 'Carta' },
          { code: 'COM', description: 'Comunicación' },
          { code: 'ODC', description: 'Solicitud de orden de cambio' },
          { code: 'SOI', description: 'Solicitud de información' },
          { code: 'SOF', description: 'Solicitud de oferta' }
        ]
      },
      {
        code: 'APY',
        description: 'Documento de apoyo',
        children: [
          { code: 'NOT', description: 'Nota técnica' },
          { code: 'FOM', description: 'Formato' },
          { code: 'FOR', description: 'Formulario' },
          { code: 'PLL', description: 'Plantilla' },
          { code: 'GUI', description: 'Guía' },
          { code: 'MAN', description: 'Manual' },
          { code: 'MET', description: 'Metodología' },
          { code: 'PRO', description: 'Procedimiento' },
          { code: 'INT', description: 'Instrucción' },
          { code: 'NOR', description: 'Norma' },
          { code: 'DRO', description: 'Diagrama de proceso' },
          { code: 'ADE', description: 'Adenda' },
          { code: 'ANE', description: 'Anejo' },
          { code: 'APE', description: 'Apéndice' },
          { code: 'LIS', description: 'Listado' },
          { code: 'ORG', description: 'Organigrama' },
          { code: 'SEP', description: 'Separatas' },
          { code: 'POL', description: 'Política' }
        ]
      },
      {
        code: 'OBR',
        description: 'Documento de obra',
        children: [
          { code: 'COB', description: 'Certificación de obra' },
          { code: 'CMP', description: 'Certificado de material o producto' },
          { code: 'CRO', description: 'Cronograma de actividades o Gantt' },
          { code: 'ENY', description: 'Ensayo o prueba' },
          { code: 'INP', description: 'Inspección' },
          { code: 'ITT', description: 'Instrucción de trabajo' },
          { code: 'LTC', description: 'Listado de comprobación' },
          { code: 'RGC', description: 'Registro no conformidades' },
          { code: 'PPI', description: 'Programa de puntos de inspección' }
        ]
      },
      {
        code: 'CAL',
        description: 'Cálculo',
        children: [
          { code: 'CST', description: 'Cálculo estructural' },
          { code: 'CIN', description: 'Cálculo instalaciones' }
        ]
      },
      {
        code: 'EST',
        description: 'Estudio',
        children: [
          { code: 'EIA', description: 'Estudio de impacto ambiental' },
          { code: 'ESF', description: 'Estudio de seguridad ferroviaria' },
          { code: 'ESS', description: 'Estudio de seguridad y salud' },
          { code: 'EET', description: 'Estudio técnico' }
        ]
      },
      {
        code: 'GES',
        description: 'Gestión',
        children: [
          { code: 'CAE', description: 'Coordinacion actividades empresariales' },
          { code: 'NOM', description: 'Nombramiento' },
          { code: 'ENC', description: 'Encuesta de calidad' },
          { code: 'INV', description: 'Inventario' },
          { code: 'LCA', description: 'Lección aprendida' },
          { code: 'LEN', description: 'Listado de entregables' },
          { code: 'GRI', description: 'Gestión de riesgos' },
          { code: 'FAC', description: 'Factura' },
          { code: 'OBC', description: 'Seguimiento de objetivos de calidad' }
        ]
      },
      {
        code: 'INC',
        description: 'Información contractual',
        children: [
          { code: 'PLE', description: 'Pliego económico' },
          { code: 'PLD', description: 'Pliego administrativo' },
          { code: 'PLT', description: 'Pliego técnico' },
          { code: 'OFA', description: 'Oferta administrativa' },
          { code: 'OFE', description: 'Oferta económica' },
          { code: 'OFT', description: 'Oferta técnica' },
          { code: 'ADJ', description: 'Adjudicación' },
          { code: 'CON', description: 'Contrato' },
          { code: 'REQ', description: 'Especificación o requisito' }
        ]
      },
      {
        code: 'INF',
        description: 'Informe',
        children: [
          { code: 'IAP', description: 'Informe aprobación' },
          { code: 'IES', description: 'Informe de evaluación independiente de seguridad' },
          { code: 'INS', description: 'Informe de inspección' },
          { code: 'ING', description: 'Informe de no regresión' },
          { code: 'ISP', description: 'Informe de supervisión' },
          { code: 'IFI', description: 'Informe final' },
          { code: 'IME', description: 'Informe mensual' },
          { code: 'INE', description: 'Informe sobre necesidad' },
          { code: 'ITE', description: 'Informe técnico' }
        ]
      },
      {
        code: 'MEM',
        description: 'Memoria',
        children: [] // No hay hijos distintos del mismo code MEM
      },
      {
        code: 'PLN',
        description: 'Plan',
        children: [
          { code: 'PCA', description: 'Plan de calidad' },
          { code: 'PCO', description: 'Plan de comunicación' },
          { code: 'PEV', description: 'Plan de evaluación' },
          { code: 'POB', description: 'Plan de obra' }
        ]
      },
      {
        code: 'PLA',
        description: 'Plano',
        children: [
          { code: 'CAD', description: 'Dibujo de CAD' },
          { code: 'MAP', description: 'Mapa' }
        ]
      },
      {
        code: 'PPT',
        description: 'Pliego de prescripciones técnicas',
        children: [
          { code: 'PPT', description: 'Pliego de prescripciones técnicas' }
        ]
      },
      {
        code: 'PRE',
        description: 'Presupuesto',
        children: [
          { code: 'BPR', description: 'Base de precios' },
          { code: 'CPR', description: 'Cuadro de precios' },
          { code: 'MED', description: 'Mediciones' },
          { code: 'PRE', description: 'Presupuesto' },
          { code: 'RSP', description: 'Resumen de presupuesto' },
          { code: 'VAE', description: 'Valoración económica' }
        ]
      },
      {
        code: 'PUB',
        description: 'Publicidad',
        children: [
          { code: 'ANU', description: 'Anuncio' },
          { code: 'CAT', description: 'Cartel' },
          { code: 'PRS', description: 'Presentación' },
          { code: 'FOL', description: 'Folleto' }
        ]
      },
      {
        code: 'VIS',
        description: 'Visualización',
        children: [
          { code: 'SIM', description: 'Simulación' },
          { code: 'INF', description: 'Infografía' },
          { code: 'FOT', description: 'Fotografía' },
          { code: 'VID', description: 'Vídeo' }
        ]
      },
      {
        code: 'XXX',
        description: 'Sin Clasificar',
        children: [
          { code: 'XXX', description: 'Sin clasificar' }
        ]
      },
      {
        code: 'YYY',
        description: 'Varios tipos de documento',
        children: [
          { code: 'YYY', description: 'Varios tipos de documento' }
        ]
      },
      {
        code: 'ZZZ',
        description: 'Otro tipo de documento',
        children: [
          { code: 'ZZZ', description: 'Otro tipo de documento' }
        ]
      },
      {
        code: 'AR',
        description: 'Arquitectura',
        children: [
          { code: 'ARI', description: 'Interiorismo y Decoración' },
          { code: 'ARM', description: 'Mobiliario' },
          { code: 'ARP', description: 'Paisajismo' },
          { code: 'ARQ', description: 'Arquitectura (Genérico)' },
          { code: 'ARS', description: 'Señalética y guiado interiores' }
        ]
      },
      {
        code: 'CA',
        description: 'Calidad',
        children: [
          { code: 'CAL', description: 'Calidad (Genérico)' }
        ]
      },
      {
        code: 'IC',
        description: 'Ingeniería Civil',
        children: [
          { code: 'ICI', description: 'Ingeniería civil (Genérico)' },
          { code: 'ICF', description: 'Instalaciones ferroviarias' },
          { code: 'ICH', description: 'Instalaciones hidráulicas' },
          { code: 'ICV', description: 'Viario' },
          { code: 'ICT', description: 'Túnel' },
          { code: 'ICR', description: 'Material rodante' },
          { code: 'ICS', description: 'Señalización' }
        ]
      },
      {
        code: 'CO',
        description: 'Construcción',
        children: [
          { code: 'COA', description: 'Auscultación y ensayos' },
          { code: 'COC', description: 'Obras complementarias' },
          { code: 'COE', description: 'Antecedentes y estudios previos' },
          { code: 'COF', description: 'Reposición de servicios afectados' },
          { code: 'COL', description: 'Logística de obra' },
          { code: 'COM', description: 'Maquinaria y medios auxiliares' },
          { code: 'CON', description: 'Construcción (Genérico)' },
          { code: 'COP', description: 'Actuaciones preventivas y correctoras' },
          { code: 'COS', description: 'Reposición de servidumbres' }
        ]
      },
      {
        code: 'ES',
        description: 'Estructuras',
        children: [
          { code: 'EST', description: 'Estructuras (Genérico)' }
        ]
      },
      {
        code: 'IN',
        description: 'Instalaciones',
        children: [
          { code: 'INC', description: 'Instalación sistema de gestión centralizada' },
          { code: 'INE', description: 'Instalaciones eléctricas' },
          { code: 'INF', description: 'Instalación fontanería' },
          { code: 'ING', description: 'Instalación gas y otros combustibles' },
          { code: 'INI', description: 'Instalaciones iluminación' },
          { code: 'INK', description: 'Instalación climatización' },
          { code: 'INM', description: 'Instalaciones mecánicas' },
          { code: 'INP', description: 'Instalación protección contra incendios' },
          { code: 'INS', description: 'Instalaciones de saneamiento' },
          { code: 'INV', description: 'Instalación ventilación' },
          { code: 'INT', description: 'Instalación telecomunicaciones' },
          { code: 'INY', description: 'Varias instalaciones' }
        ]
      },
      {
        code: 'GE',
        description: 'Gestión',
        children: [
          { code: 'GEA', description: 'Gestión administrativa' },
          { code: 'GEC', description: 'Comunicación y marketing' },
          { code: 'GEE', description: 'Gestión económica' },
          { code: 'GEI', description: 'Tecnologías de la Información' },
          { code: 'GEL', description: 'Gestión legal' },
          { code: 'GER', description: 'Supervisión del proyecto' },
          { code: 'GES', description: 'Gestión (Genérico)' },
          { code: 'GET', description: 'Planificación técnica' },
          { code: 'GEX', description: 'Expropiación' }
        ]
      },
      {
        code: 'MA',
        description: 'Medio Ambiente',
        children: [
          { code: 'MAM', description: 'Medio Ambiente (Genérico)' },
          { code: 'MAE', description: 'Eficiencia energética' },
          { code: 'MAR', description: 'Gestión de residuos' },
          { code: 'MAS', description: 'Sostenibilidad' }
        ]
      },
      {
        code: 'ME',
        description: 'Mantenimiento y Explotación',
        children: [
          { code: 'MEI', description: 'Inventario bienes inmuebles' },
          { code: 'MEM', description: 'Mobiliario' },
          { code: 'MEO', description: 'Mantenimiento y Explotación (Genérico)' },
          { code: 'MEX', description: 'Explotación' }
        ]
      },
      {
        code: 'MI',
        description: 'Modelado información',
        children: [
          { code: 'MIC', description: 'Modelado de información de Construcción' },
          { code: 'MII', description: 'MIC Interoperabilidad' },
          { code: 'MIG', description: 'Información geográfica (GIS)' }
        ]
      },
      {
        code: 'RE',
        description: 'Redes',
        children: [
          { code: 'RDA', description: 'Red agua' },
          { code: 'RDE', description: 'Red electricidad' },
          { code: 'RDG', description: 'Red gas' },
          { code: 'RDS', description: 'Red saneamiento' },
          { code: 'RDT', description: 'Red telecomunicaciones' }
        ]
      },
      {
        code: 'SS',
        description: 'Seguridad y Salud',
        children: [
          { code: 'SSA', description: 'Seguridad y Salud (Genérico)' },
          { code: 'SSP', description: 'Instalación protección y seguridad' }
        ]
      },
      {
        code: 'TG',
        description: 'Topografía y Geodesia',
        children: [
          { code: 'TGE', description: 'Entorno' },
          { code: 'TGH', description: 'Hidrogeología' },
          { code: 'TGL', description: 'Geología' },
          { code: 'TGM', description: 'Movimiento de tierras' },
          { code: 'TGS', description: 'Topografía y Geodesia (Genérico)' },
          { code: 'TGT', description: 'Geotecnia' }
        ]
      },
      {
        code: 'UR',
        description: 'Urbanismo',
        children: [
          { code: 'UR', description: 'Urbanismo' }
        ]
      },
      {
        code: 'URB',
        description: 'Urbanismo (Genérico)',
        children: [
          { code: 'URP', description: 'Planeamiento urbanístico' }
        ]
      },
      {
        code: 'XX',
        description: 'Sin Clasificar',
        children: [
          { code: 'XXX', description: 'Sin clasificar' }
        ]
      },
      {
        code: 'YY',
        description: 'Múltiples disciplinas',
        children: [
          { code: 'YYY', description: 'Múltiples disciplinas' }
        ]
      },
      {
        code: 'ZZ',
        description: 'Sin disciplina',
        children: [
          { code: 'ZZZ', description: 'Sin disciplina' }
        ]
      }

    ],
    
    descriptionCodes: [
      { code: "GEN", description: "General" },
      { code: "ESA", description: "Estado Actual" },
      { code: "TOP", description: "Topografía" },
      { code: "GEO", description: "Geotecnia y Tratamientos del Terreno" },
      { code: "PLA", description: "Plataforma y Movimiento de Tierras" },
      { code: "DRE", description: "Drenaje" },
      { code: "PRI", description: "Prismas de instalaciones" },
      { code: "EST", description: "Estructuras" },
      { code: "ARQ", description: "Arquitectura" },
      { code: "URB", description: "Urbanización" },
      { code: "VIL", description: "Viales" },
      { code: "IEF", description: "Electrificación" },
      { code: "IEN", description: "Suministro de Energía" },
      { code: "IEL", description: "Instalaciones Eléctricas de Baja Tensión" },
      { code: "ICO", description: "Instalaciones de Comunicaciones" },
      { code: "ISC", description: "Instalaciones de Seguridad Civil" },
      { code: "IFS", description: "Instalaciones Fontanería y Saneamiento" },
      { code: "IME", description: "Instalaciones Mecánicas" },
      { code: "AUX", description: "Construcciones e Instalaciones Auxiliares" },
      { code: "SYS", description: "Seguridad y Salud" },
      { code: "OCE", description: "Ocupación de Espacios" },
      { code: "DEM", description: "Demoliciones" },
      { code: "MAM", description: "Medio Ambiente" }
    ],

    versionTypes: [
      { code: 'S', description: 'Inicial - Solo interno del equipo' },
      { code: 'V', description: 'Para coordinación - compartido' },
      { code: 'P', description: 'Publicado para aprobación' },
      { code: 'A', description: 'Aprobado' },
      { code: 'B', description: 'Parcialmente aprobado (con comentarios)' },
      { code: 'C', description: 'Rechazado' },
      { code: 'AB', description: 'As-built (final)' },
    ],



  }),


  created() {
    this.yearValues = this.getYearValues()    
    this.versionValues = [...Array(100).keys()] // [ 0, 1, 2, 3, 4... 99]
    // this.versionValues.shift() // saca el 0

    
    this.getExtraFields()

    // al subir version detectamos patron de numero version, y bloqueamos la cifra o el digito segun el proyecto
    // proyecto 'redaccion' sube el numero. proyecto 'ejecucion' sube la letra
    if (! this.isNewFile) {

        if (this.hasVersionNumber()) {
            let versionNumber = this.versionFileName.match(this.regex)[0]  // [0] la primera ocurrencia que encuentra y en teoria unica (-RA1)
            versionNumber = versionNumber.replace('-R', '') // A1
            this.version.cliente = versionNumber.substring(0,1) // A
            this.version.interna = versionNumber.substring(1) // 1
        }

        // Distincion de proyecto por ID. Por campo extra es posible pero más dificil de traer aqui el dato.
        // Para las pocas veces que ocurrirá meter aqui ids de proyectos que precisen mover la cifra
        if (this.project.id == 421) {
            this.versionType = 'interna'
        }

    }
  },


  computed: {

    ...mapGetters({
        project: 'app/project',
    }),

    filteredChildren() {
      const parent = this.documentTypes.find(d => d.code === this.selectedParent)
      return parent ? parent.children : []
    },


  },

  watch: {
    dataOptions: {
      handler() {
        // cada vez que cambie dataOptions, generar el codigo
        this.generateCode()
      },
      deep: true,
      immediate: true
    }
  },

  methods: {

    getYearValues() {
        // rellenar yearValues con año actual +2 y -2
        let options = [];

        [-2, -1, 0, 1, 2].forEach(function(index) {
            let year = moment().add(index, 'year')
            options.push({value: year.format('YY'), name: year.format('YYYY')})
        })

        return options
    },

    generateCode(){
        let {
          projectFileCode,
          companyCode,
          faceCode,
          fileType,
          phaseSubdivisionNumber,
          descriptionCode,
          number,
          versionType,
          versionNumber
        } = this.dataOptions

        // if subdivision, añadir año de subdivisión al faceCode
        if (this.phaseSubdivision && faceCode) {
          // simplemente concatenamos el año de subdivisión al faceCode
          faceCode = faceCode + (phaseSubdivisionNumber ? phaseSubdivisionNumber.toString().padStart(2, '0') : '')
        }

        // number debe tener un valor de 3 digitos por defecto sera 001
        if (number > 0) {
          number = number.toString().padStart(3, '0')
        } 

        // number of version
        let versionCode = ''
        if ( versionType && versionNumber) {
          // si hay versionType y versionNumber, generar el codigo de version concatenando 
          versionCode = `${versionType}${versionNumber.toString().padStart(2, '0')}`
        }

        // Concatenar con "_" solo los valores no vacíos
        const parts = [
          projectFileCode,
          companyCode, 
          faceCode, 
          fileType,
          descriptionCode,
          number,
          versionCode
        ]
        .filter(Boolean)

        this.codedName = parts.join('_')
    },


    // carga los custom fields del proyecto
    async getExtraFields() {
      await axios.get(`/api/v2/project/${this.project.id}/extrafields-assigned`)
        .then((response) => {
          const extrafields = response.data.data.extrafields;
          const fileCode = extrafields.find(field => field.field.code === 'file-code-document-codification');

          this.dataOptions.projectFileCode = fileCode ? fileCode.value_free : '';
          const companyCode = extrafields.find(field => field.field.code === 'company-code-document-codification');
          this.dataOptions.companyCode = companyCode ? companyCode.value_free : '';
        })
        .catch((error) => {
          this.$notify.error("error obteniendo campos personalizados del proyecto");
        });
    },



    // aplica el codigo de nombre generado al campo custom_name
    async generateName() {

        // emit al componente padre validationtask-completion-modal con lo generado
        let customName = this.codedName // codedName dificil de setear, trabajamos con copia

        const nextNumber = await axios.get(`/api/v2/project/${this.project.id}/documentcodification/number`, {
            params: {
                code: customName,
            }
        })

        if (nextNumber.data.next_number) {
            this.dataOptions.number = nextNumber.data.next_number
            if (this.dataOptions.number != 1) {
                this.generateCode() // regeneramos el codigo con el nuevo numero
            }
        }

        this.$emit('generatedCodename', {
            desc_name: this.desc_name || '',
            custom_name: this.codedName,
            coded_name: this.codedName ? 1 : 0,
        })

    },


    // detecta si el fichero al que vamos a subir version tenia la info de version en su nombre, es decir el original RXX que luego fue sustituido por "-R{letra}{digito}"
    hasVersionNumber() {
        return this.regex.test(this.versionFileName);
    }


  }
}
</script>